import { get } from './P3Api';

class CategoryGroupSubgroup1Api {
  static async getCategoryGroupSubgroup1(categoryId, groupId) {
    return get(`categories/${categoryId}/groups/${groupId}/subgroup/1`);
  }
}

export default CategoryGroupSubgroup1Api;
